'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import styled from 'styled-components'

export const DesktopWrapper = styled.div<{
  footerWrapperBackground?: string
  footerWrapperBorderTop?: string
}>`
  // eslint-disable-next-line no-unneeded-ternary
  background: ${({ footerWrapperBackground }) => footerWrapperBackground || '#fff'};
  border-top: ${({ footerWrapperBorderTop }) => footerWrapperBorderTop || '10px solid #fafafa'};
  padding: 40px 20px;
`
export const DesktopContainer = styled.div<{
  containerWidth?: string
  containerMaxWidth?: string
}>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
  width: ${({ containerWidth }) => (containerWidth ? containerWidth : '1100px')};
  margin: 0 auto;
  ${({ containerMaxWidth }) => containerMaxWidth && `max-width: ${containerMaxWidth}`};

  @media (max-width: 700px) {
    width: 100%;
    display: block;
  }
`

export const DesktopCompanyDetails = styled.div`
  border-right: 1px solid #eee;
`

export const LinksWrapper = styled.div`
  &:last-child {
    border: none;
  }
  border-right: 1px solid #eee;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 700px) {
    align-items: flex-start;
  }
`

export const DesktopItemWrapper = styled.div`
  display: grid;
  grid-template-rows: repeat(3, 1fr);
`

export const DesktopTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: #414a53;
  margin: 5px 0 5px 0;
  text-transform: capitalize;

  @media (max-width: 700px) {
    margin: 15px 0 5px 0;
  }
`

export const DesktopLink = styled.a`
  font-size: 12px;
  color: #434f5a;
  margin: 10px 0;
  cursor: pointer;
  text-decoration: none;
`
